import React from "react";
import { Button, Table, Textfield } from "../../../../components/core";
import { NumberFormatBase, PatternFormat } from "react-number-format";

export default function StorageFeeTable({
	data = [],
	addedData = [],
	handleAddForm,
	handleChangeForm,
	handleChangeData,
	disabled = false,
}) {
	return (
		<div>
			<table
				className={
					"w-2/3 border-secondary-buttonHeaderGray border-x-2 border-b-2 p-2"
				}
			>
				<thead>
					<tr className="bg-primary-primaryYellow h-16">
						<th className="text-left p-2">Storage Duration</th>
						<th className="text-left p-2">Storage Fee</th>
					</tr>
				</thead>
				<tbody>
					{data.length < 1 && (
						<tr className="h-12 even:bg-secondary-buttonGray bg-white">
							<td className="px-2 py-4" colSpan={2}>
								<p className="text-center">No Fees</p>
							</td>
						</tr>
					)}
					{data.length > 0 &&
						data.map((obj, key) => {
							return (
								<tr
									className="h-12 even:bg-secondary-buttonGray bg-white"
									key={key}
								>
									<td className="px-2 py-4">
										<div className="flex gap-2">
											<p className="my-auto">upto</p>
											<Textfield
												disabled={disabled}
												placeholder={"XX"}
												value={data[key].hours}
												id={key}
												name="hours"
												onChange={(e) => {
													var numberPattern = /^(\d+)?$/;

													if (
														numberPattern.test(e.target.value) &&
														(parseFloat(e.target.value) <= 720 ||
															e.target.value === "")
													) {
														handleChangeData(e);
													}
												}}
											/>
											<p className="my-auto">hrs</p>
										</div>
									</td>
									<td className="px-2 py-4 flex gap-2">
										<div className="flex gap-2">
											<p className="my-auto">P</p>
											<Textfield
												disabled={disabled}
												placeholder={"00.00"}
												value={data[key].fee}
												id={key}
												name="fee"
												onChange={(e) => {
													var numberPattern = /^\d+(\.\d{0,2})?$/; // Allowing up to 2 decimal places
													console.log(
														numberPattern.test(e.target.value) ||
														e.target.value === ""
													);
													if (
														numberPattern.test(e.target.value) ||
														e.target.value === ""
													) {
														if (
															parseFloat(e.target.value) <= 1000000000 ||
															e.target.value === ""
														) {
															handleChangeData(e);
														}
													}
												}}
											/>
										</div>
									</td>
								</tr>
							);
						})}
					{addedData.length > 0 &&
						addedData.map((data, key) => {
							return (
								// <tr
								// 	className="h-12 even:bg-secondary-buttonGray bg-white"
								// 	key={key}
								// >
								// 	<td className="px-2 py-4">
								// 		<div className="flex gap-2">
								// 			<p className="my-auto">upto</p>
								// 			<NumberFormatBase
								// 				placeholder={"XX"}
								// 				pattern="##"
								// 				customInput={Textfield}
								// 				onChange={handleChangeForm}
								// 				name="hours"
								// 				id={key}
								// 				max={4} maxLength={4}
								// 				value={addedData[key].hours}
								// 			/>
								// 			<p className="my-auto">hrs</p>
								// 		</div>
								// 	</td>
								// 	<td className="px-2 py-4 flex gap-2">
								// 		<div className="flex gap-2">
								// 			<p className="my-auto">P</p>
								// 			<NumberFormatBase
								// 				placeholder={"00.00"}
								// 				pattern="##.##"
								// 				max={6} maxLength={6}
								// 				customInput={Textfield}
								// 				onChange={handleChangeForm}
								// 				name="fee"
								// 				id={key}
								// 				value={addedData[key].fee}
								// 			/>
								// 		</div>
								// 	</td>
								// </tr>
								<tr
									className="h-12 even:bg-secondary-buttonGray bg-white"
									key={key}
								>
									<td className="px-2 py-4">
										<div className="flex gap-2">
											<p className="my-auto">upto</p>
											<Textfield
												disabled={disabled}
												placeholder={"XX"}
												value={addedData[key].hours}
												id={key}
												name="hours"
												onChange={(e) => {
													var numberPattern = /^(\d+)?$/;

													if (
														numberPattern.test(e.target.value) &&
														(parseFloat(e.target.value) <= 720 ||
															e.target.value === "")
													) {
														handleChangeForm(e);
													}
												}}
											/>
											<p className="my-auto">hrs</p>
										</div>
									</td>
									<td className="px-2 py-4 flex gap-2">
										<div className="flex gap-2">
											<p className="my-auto">P</p>
											<Textfield
												disabled={disabled}
												placeholder={"00.00"}
												value={addedData[key].fee}
												id={key}
												name="fee"
												onChange={(e) => {
													var numberPattern = /^\d+(\.\d{0,2})?$/; // Allowing up to 2 decimal places
													console.log(
														numberPattern.test(e.target.value) ||
														e.target.value === ""
													);
													if (
														numberPattern.test(e.target.value) ||
														e.target.value === ""
													) {
														if (
															parseFloat(e.target.value) <= 1000000000 ||
															e.target.value === ""
														) {
															handleChangeForm(e);
														}
													}
												}}
											/>
										</div>
									</td>
								</tr>

							);
						})}
					<tr className="h-12 bg-secondary-buttonGray">
						<td className="px-2 py-4 text-center" colSpan={2}>
							<Button
								value={"Add fee"}
								className={"p-2"}
								onClick={handleAddForm}
								disabled={disabled}
							/>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	);
}
